module.exports = __webpack_public_path__ + "img/slider_node.abb19455.png";